
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      oss: "oss"
    }),
    kvDesktop(): string {
      return this.isCN
        ? this.oss.am_emptiness_phonecase_iphone18_pro_kv_cn
        : this.oss.am_emptiness_phonecase_iphone18_pro_kv_en;
    },
    kvMobile(): string {
      return this.isCN
        ? this.oss.am_emptiness_phonecase_iphone18_pro_kv_cn_mobile
        : this.oss.am_emptiness_phonecase_iphone18_pro_kv_en_mobile;
    },
    featureItems(): Array<{ key: string; image: string }> {
      return [
        {
          key: "AMEmptinessPhonecaseIphone18Pro.feature01",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_02
        },
        {
          key: "AMEmptinessPhonecaseIphone18Pro.feature02",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_05
        },
        {
          key: "AMEmptinessPhonecaseIphone18Pro.feature03",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_03
        },
        {
          key: "AMEmptinessPhonecaseIphone18Pro.feature04",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_04
        },
        {
          key: "AMEmptinessPhonecaseIphone18Pro.feature05",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_01
        },
        {
          key: "AMEmptinessPhonecaseIphone18Pro.feature06",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_06
        }
      ];
    },
    protectionItems(): Array<{ key: string; image: string }> {
      return [
        {
          key: "AMEmptinessPhonecaseIphone18Pro.protection01",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_03
        },
        {
          key: "AMEmptinessPhonecaseIphone18Pro.protection02",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_04
        },
        {
          key: "AMEmptinessPhonecaseIphone18Pro.protection03",
          image: this.oss.am_emptiness_phonecase_iphone18_pro_08
        }
      ];
    },
    communitySlots(): number[] {
      return [1, 2, 3, 4, 5, 6];
    }
  }
});
